@if (message) {
  <div
    [ngClass]="'soft-validation soft-validation-' + message.type"
    >
    @switch (message.type) {
      @case ('error') {
        <i
          class="fa-regular fa-circle-xmark soft-validation-icon"
        ></i>
      }
      @case ('warning') {
        <i
          class="fa-regular fa-circle-exclamation soft-validation-icon"
        ></i>
      }
      @case ('info') {
        <i
          class="fa-regular fa-circle-info soft-validation-icon"
        ></i>
      }
      @case ('success') {
        <i
          class="fa-regular fa-circle-check soft-validation-icon"
        ></i>
      }
    }
    <strong>
      {{ message.subject | translate | interpolate: message.data }}
    </strong>
    {{ message.message | translate | interpolate: message.data }}
  </div>
}
